<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses" v-resize="onResize" style="z-index: 1">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import { version } from "../package.json";
import * as firebase from "firebase/app";
import "firebase/messaging";
import themeConfig from "@/../themeConfig.js";
import deMessages from "devextreme/localization/messages/tr.json";
import ruMessages from "devextreme/localization/messages/en.json";
import { locale, loadMessages } from "devextreme/localization";
import { isMobile, isAndroid, isIOS } from "mobile-device-detect";
import { userTracker, customerSupport, logger } from "@/utils/signalR";
import resize from "vue-resize-directive";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  metaInfo: {
    changed(metaInfo) {
      firebase.analytics().logEvent("sayfa", "sayfaAdi", metaInfo.title);
    },
  },
  directives: {
    resize,
  },
  data() {
    return {
      vueAppClasses: [],
      messaging: firebase.messaging(),
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
    $route(to, from) {
      if (logger) {
        from.params.paramsId
          ? (from = from.params.paramsId)
          : (from = from.name);
        const fromRoute = {
          event: 2,
          path: from,
        };
        this.$store.dispatch("signalRStore/updateCurrentLocation", fromRoute);

        to.params.paramsId ? (to = to.params.paramsId) : (to = to.name);
        const toRoute = {
          event: 1,
          path: to,
        };
        this.$store.dispatch("signalRStore/updateCurrentLocation", toRoute);
      }
    },
  },
  methods: {
    handleVisibilityChange() {
      if (document.hidden) {
        const route = {
          event: 2,
          path: this.$route.params.paramsId
            ? this.$route.params.paramsId
            : this.$route.name,
        };
        this.$store.dispatch("signalRStore/updateCurrentLocation", route);
      } else {
        // console.log("Sekme veya pencere ön planda.");
        const route = {
          event: 1,
          path: this.$route.params.paramsId
            ? this.$route.params.paramsId
            : this.$route.name,
        };
        this.$store.dispatch("signalRStore/updateCurrentLocation", route);
      }
    },
    async manageTraceID() {
      if (logger) {
        await this.$store.dispatch("signalRStore/getTraceId");
        let traceID = localStorage.getItem("traceID");
        const route = {
          event: 1,
          path: this.$route.params.paramsId
            ? this.$route.params.paramsId
            : this.$route.name,
        };
        this.$store.dispatch("signalRStore/updateCurrentLocation", route);
      }
    },
    onResize() {
      const element = document.querySelector(".vx-navbar");
      if (element) {
        const height = element.offsetHeight;
        this.$store.commit("horizontalNavStore/setNavbarHeight", height);
      }
    },
    receiveMessage() {
      // try {
      //   this.messaging.onMessage(payload => {
      //     var notification = payload.notification;
      //     this.$vs.notify({
      //       time: 4000,
      //       title: notification.title,
      //       text: notification.body,
      //       color: "success",
      //       position: "top-right",
      //       icon: "mail"
      //     });
      //   });
      // } catch (e) {}
    },
    toggleClassInBody(className) {
      if (className === "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className === "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  async mounted() {
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.onResize();
    this.$store.dispatch(
      "signalRStore/updateCurrentLocation",
      this.$route.fullPath
    );
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    if (!customerSupport || !userTracker) {
      await this.$store.dispatch("signalRStore/hubStarts");
    }
    if (localStorage.getItem("UserData")) {
      await this.manageTraceID();
    }
    await this.$store.dispatch("signalRStore/getAllAgents");

    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    var user = JSON.parse(localStorage.getItem("UserData"));
    if (user && user.email) {
      this.$analytics.setUserId(user.email);
    }

    this.$analytics.setUserProperties(user);

    if (isMobile) {
      if (isAndroid)
        window.location.href = "market://details?id=com.d7ksuper.dinamoerp";
      if (isIOS)
        window.location.href =
          "https://apps.apple.com/tr/app/d7ksuper/id1528409473?l=tr";
    } else {
    }
    var customerJson = await this.$http.get("v1/User/GetUserInfo");
    this.customer = customerJson.data;
    this.$store.commit("signalRStore/setCustomerDesc", this.customer);
    if (this.$route.name == "finansHome") {
      this.paraBirimiGoster = true;
    } else {
      this.paraBirimiGoster = false;
    }
  },
  async created() {
    const dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);
    loadMessages(deMessages);
    locale("tr");

    firebase
      .messaging()
      .requestPermission()
      .then(() => {
        return firebase
          .messaging()
          .getToken()
          .then((token) => {
            localStorage.setItem("NotifiToken", token);

            var userData = localStorage.getItem("UserData");
            if (userData != null)
              this.$http.get("v1/User/TokenRegisterWeb?regToken=" + token);

            fetch(
              "https://iid.googleapis.com/iid/v1/" +
                token +
                "/rel/topics/general",
              {
                method: "POST",
                headers: new Headers({
                  Authorization:
                    "key=AAAA2RQPIqw:APA91bHmKTHP2o_IoJYBwN_XWYmgmtEQ5ESucvM7QFKPKDp675OD9Ncgo-zxiXuC5Z_c2pWcjucjWsVC4euzZzr9UbTNY_enNcPgVaZmDnF5ApQmNcKgNGWNscx7ReD1jc-WCCKL4OEo",
                }),
              }
            )
              .then((response) => {
                if (response.status < 200 || response.status >= 400) {
                  // throw (
                  //   "Error subscribing to topic: " +
                  //   response.status +
                  //   " - " +
                  //   response.text()
                  // );
                }
              })
              .catch((error) => {
                // console.error(error);
              });
          })
          .catch((err) => {
            // console.log("Error", err);
          });
      });

    this.receiveMessage();
  },
  // updated: function () {
  //   this.$nextTick(function () {
  //     this.onResize();
  //   });
  // },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);

    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  },
};
</script>
